import React, { useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LiveAriaMessage } from './LiveAriaMessage';
import './LiveAria.scss';

export const LiveAriaContext = React.createContext(null);

const LiveAriaContextWrapper = props => {
  const [ariaText, setAriaText] = useState('');
  const [key, setKey] = useState(0);
  const location = useLocation();
  const refText = useRef(null);
  const timeoutIdRef = useRef(null);

  useLayoutEffect(() => {
    changeState(() => {
      const activeElement = document.activeElement;

      const hasActiveElement = activeElement && activeElement.type && activeElement.type !== 'button';

      return `${hasActiveElement ? '' : 'Loaded.'} ${refText.current?.innerText ? refText.current.innerText : ''}`;
    });
  }, [location]);

  const changeState = ariaText => {
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(() => {
      setAriaText(ariaText);
      setKey(v => v + 1);
    }, 50);
  };

  return (
    <LiveAriaContext.Provider
      value={{
        changeState,
        refText,
        key,
        ariaText,
      }}
    >
      <LiveAriaMessage />

      {props.children}
    </LiveAriaContext.Provider>
  );
};

export default LiveAriaContextWrapper;

